import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {Select} from 'primeng/select';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {DateHelper} from '../../../../../../helper/date.helper';
import {StatisticFilter} from '../../../../model/api/StatisticFilter';
import {SessionService} from '../../../../../../services/session.service';
import {ViewService} from '../../../../../shared/service/view.service';
import {PlayerSessionService} from '../../../../service/player-session.service';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {DropdownDomainComponent} from '../../../../../shared/common/dropdown-domain/dropdown-domain.component';
import {DomainValue} from '../../../../../../model/DomainValue';
import {
  DOMAIN_VALUE_CD_MATCH_TYPE_CAPTAINGAME, DOMAIN_VALUE_CD_MATCH_TYPE_CAPTAINGAME_FIX, DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL,
  DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL_DECIDER,
  DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL, DOMAIN_VALUE_CD_MATCH_TYPE_ROUND_ROBIN,
  DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME, DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME_DOUBLE,
  DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME_DOUBLE_FIX,
  DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME_FIX, DOMAIN_VALUE_CD_MATCH_TYPE_TRIPLE,
  DOMAIN_VALUES_DART_TYPE,
  DOMAIN_VALUES_EVENT_TYPE,
  DOMAIN_VALUES_MATCH_TYPE_FILTER,
  Domains
} from '../../../../../../../assets/domains/domains';
import {Divider} from 'primeng/divider';
import {PrimeTemplate} from 'primeng/api';
import {NgTemplateOutlet} from '@angular/common';
import {Popover} from 'primeng/popover';

@Component({
  selector: 'app-player-profile-statistics-filter',
  standalone: true,
  imports: [
    Select,
    TranslatePipe,
    FormsModule,
    Button,
    Tooltip,
    DropdownDomainComponent,
    Divider,
    PrimeTemplate,
    NgTemplateOutlet,
    Popover
  ],
  templateUrl: './player-profile-statistics-filter.component.html',
  styleUrl: './player-profile-statistics-filter.component.scss'
})
export class PlayerProfileStatisticsFilterComponent implements OnInit
{
  public view = inject(ViewService);
  private translate = inject(TranslateService);
  private sessionService = inject(SessionService);
  private playerSessionService = inject(PlayerSessionService);

  @Output() onFilterChanged = new EventEmitter<StatisticFilter>();
  @Input() showMatchMode = false;
  @Input() showStartPoints = false;
  @Input() showYearMonth = true;
  @Input() showYearlyQuarterlyMonthly = false;
  @Input() showEventType = true;
  @Input() showEventKind = true;
  @Input() showMatchType = true;
  @Input() showDartType = true;
  @Input() locked = false;

  matchModeValues: DomainValue[];
  selectedMatchMode: number;
  startPoints: any[];
  selectedStartPoints: number;

  years: any[];
  selectedYear: number;
  months: any[];
  selectedMonth: number;

  eventTypeValues: DomainValue[];
  selectedEventTypeCd: string;
  // eventKindValues: DomainValue[];
  // selectedEventKindCd: string;
  matchTypeValues: DomainValue[];
  selectedMatchTypeCd: string;
  dartTypeValues: DomainValue[];
  selectedDartTypeCd: string;

  ngOnInit(): void
  {
    this.initYearsMonths();
    this.translate.get('NAME').subscribe(() =>
    {
      this.initMatchMode();
      this.initStartPoints();

      this.eventTypeValues = Domains.initializeListWithAllAndValues(DOMAIN_VALUES_EVENT_TYPE, this.translate);
      this.eventTypeValues[0].value = this.translate.instant('TOURNAMENT_AND_LEAGUE');
      this.selectedEventTypeCd = this.playerSessionService.statisticFilterEventType;

      /*this.eventKindValues = Domains.initializeListWithAllAndValues(DOMAIN_VALUES_EVENT_KIND, this.translate);
      this.eventKindValues[0].value = this.translate.instant('ALL_EVENT_KINDS');
      this.selectedEventKindCd = this.playerSessionService.statisticFilterEventKind;*/

      this.matchTypeValues = Domains.initializeListWithAllAndValues(DOMAIN_VALUES_MATCH_TYPE_FILTER, this.translate);
      this.matchTypeValues[0].value = this.translate.instant('ALL_KINDS');
      this.selectedMatchTypeCd = this.playerSessionService.statisticFilterMatchType;
      console.log('this.selectedMatchTypeCd 1: ' + this.selectedMatchTypeCd);
      // if (!this.selectedMatchTypeCd)
      //   this.selectedMatchTypeCd = DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL;
      console.log('this.selectedMatchTypeCd 2: ' + this.selectedMatchTypeCd);

      this.dartTypeValues = Domains.initializeListWithAllAndValues(DOMAIN_VALUES_DART_TYPE, this.translate);
      this.dartTypeValues[0].value = this.translate.instant('STEEL_EDART');
      this.selectedDartTypeCd = this.playerSessionService.statisticFilterDartType;

      this.onFilterChanged.emit(this.getFilter());
    });
  }

  public filterChanged(): void
  {
    if (this.selectedYear > 0 && this.selectedYear < 10 && this.selectedMonth > 0)
      this.selectedMonth = undefined;

    this.playerSessionService.statisticFilterMatchMode = this.selectedMatchMode;
    this.playerSessionService.statisticFilterStartPoints = this.selectedStartPoints;
    this.playerSessionService.statisticFilterYear = this.selectedYear;
    this.playerSessionService.statisticFilterMonth = this.selectedMonth;
    this.playerSessionService.statisticFilterEventType = this.selectedEventTypeCd;
    // this.playerSessionService.statisticFilterEventKind = this.selectedEventKindCd;
    this.playerSessionService.statisticFilterMatchType = this.selectedMatchTypeCd;
    this.playerSessionService.statisticFilterDartType = this.selectedDartTypeCd;

    this.onFilterChanged.emit(this.getFilter());
  }

  public hasFilter(): boolean
  {
    if (this.showStartPoints && this.selectedStartPoints > 0)
      return true;
    if (this.showYearMonth && (this.selectedYear > 0 || this.selectedMonth > 0))
      return true;
    if (this.hasFilterDomains())
      return true;
    return false;
  }

  public hasFilterDomains(): boolean
  {
    // if (this.selectedEventTypeCd || this.selectedEventKindCd || this.selectedMatchTypeCd || this.selectedDartTypeCd)
    if (this.selectedEventTypeCd || (this.selectedMatchTypeCd !== DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL) || this.selectedDartTypeCd)
      return true;
    return false;
  }

  private getFilter(): StatisticFilter
  {
    const filter = {} as StatisticFilter;
    if (this.locked)
      return filter;

    if (this.showStartPoints)
      filter.startPoints = this.selectedStartPoints || undefined;

    if (this.showYearMonth)
    {
      if (!this.selectedYear)
        this.selectedMonth = undefined;

      filter.year = this.selectedYear;
      filter.month = this.selectedMonth;
    }

    if (this.showEventType)
      filter.eventTypeCd = this.selectedEventTypeCd || undefined;
    // if (this.showEventKind)
    //   filter.eventKindCd = this.selectedEventKindCd || undefined;
    if (this.showMatchType)
      filter.matchTypeCdList = this.getMatchTypeCdList(this.selectedMatchTypeCd);
    if (this.showDartType)
      filter.dartTypeCd = this.selectedDartTypeCd || undefined;

    console.log('Filter: ', filter);
    return filter;
  }

  private getMatchTypeCdList(matchTypeCd: string): string[]
  {
    if (matchTypeCd)
    {
      if (matchTypeCd === DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL)
      {
        return [DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL,
          DOMAIN_VALUE_CD_MATCH_TYPE_ROUND_ROBIN,
          DOMAIN_VALUE_CD_MATCH_TYPE_CAPTAINGAME,
          DOMAIN_VALUE_CD_MATCH_TYPE_CAPTAINGAME_FIX];
      }
      else if (matchTypeCd === DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL)
      {
        return [DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL,
          DOMAIN_VALUE_CD_MATCH_TYPE_DOPPEL_DECIDER,
          DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME_DOUBLE,
          DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME_DOUBLE_FIX];
      }
      else if (matchTypeCd === DOMAIN_VALUE_CD_MATCH_TYPE_TRIPLE)
        return [DOMAIN_VALUE_CD_MATCH_TYPE_TRIPLE, 'TRIPLE'];  // Wurde fehlerhaft mit "TP" und "TRIPLE" gespeichert
      else if (matchTypeCd === DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME)
        return [DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME, DOMAIN_VALUE_CD_MATCH_TYPE_TEAMGAME_FIX];
    }
    return undefined;
  }

  private initMatchMode(): void
  {

  }
  private initStartPoints(): void
  {
    // if (this.selectedMatchMode === 0)
    {
      this.startPoints = [
        // {label: this.translate.instant('ALL'), value: undefined},
        {label: 'X01', value: undefined},
        {label: '101', value: 101},
        {label: '170', value: 170},
        {label: '301', value: 301},
        // {label: '401', value: 401},
        {label: '501', value: 501},
        {label: '701', value: 701},
        {label: '901', value: 901},
        {label: '1001', value: 1001},
      ];
      this.selectedStartPoints = this.playerSessionService.statisticFilterStartPoints;
    }
  }

  private initYearsMonths(): void
  {
    if (this.showYearMonth)
    {
      const dateHelper = new DateHelper();
      this.years = dateHelper.getFilterYears(2025);
      if (this.showYearlyQuarterlyMonthly)
      {
        this.years.unshift({label: this.translate.instant('MONTHLY'), value: 3});
        this.years.unshift({label: this.translate.instant('QUARTERLY'), value: 2});
        this.years.unshift({label: this.translate.instant('YEARLY'), value: 1});
      }
      this.years.unshift({label: this.translate.instant('ALL_PERIODS'), value: undefined});
      this.selectedYear = this.playerSessionService.statisticFilterYear;
      if (this.selectedYear > 0 && this.selectedYear < 10 && !this.showYearlyQuarterlyMonthly)
        this.selectedYear = undefined;

      this.months = dateHelper.getFilterMonths(this.sessionService.languageCode);
      this.months.unshift({name: this.translate.instant('ALL_MONTHS'),
        nameShort: this.translate.instant('ALL_MONTHS'), value: undefined});
      this.selectedMonth = this.playerSessionService.statisticFilterMonth;
    }
  }

  public clearFilter(): void
  {
    this.selectedMatchMode = 0;
    this.selectedStartPoints = undefined;

    if (this.showYearMonth)
    {
      this.selectedYear = undefined;
      this.selectedMonth = undefined;
    }
    if (this.showEventType)
      this.selectedEventTypeCd = '';
    // if (this.showEventKind)
    //  this.selectedEventKindCd = '';
    if (this.selectedMatchTypeCd !== DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL)
      this.selectedMatchTypeCd = DOMAIN_VALUE_CD_MATCH_TYPE_EINZEL;
    if (this.showDartType)
      this.selectedDartTypeCd = '';

    this.filterChanged();
  }
}
